import { version } from '../util/version';
import { LogLevel } from './types';
const getDefaultLogLevel = () => LogLevel.INFO;
export const MESSAGE_PREFIX = `@atlassiansox/feature-flag-web-client@${version} -`;
export default class LoggerWrapper {
  constructor(options = {}) {
    this.isEnabled = options.enabled !== undefined ? options.enabled : true;
    this.logger = options.logger || console;
    this.logLevel = options.level || getDefaultLogLevel();
  }
  debug(...data) {
    if (this.shouldLog(LogLevel.DEBUG)) {
      this.logger.debug(MESSAGE_PREFIX, ...data);
    }
  }
  info(...data) {
    if (this.shouldLog(LogLevel.INFO)) {
      this.logger.info(MESSAGE_PREFIX, ...data);
    }
  }
  log(...data) {
    if (this.shouldLog(LogLevel.LOG)) {
      this.logger.log(MESSAGE_PREFIX, ...data);
    }
  }
  warn(...data) {
    if (this.shouldLog(LogLevel.WARN)) {
      this.logger.warn(MESSAGE_PREFIX, ...data);
    }
  }
  error(...data) {
    if (this.shouldLog(LogLevel.ERROR)) {
      this.logger.error(MESSAGE_PREFIX, ...data);
    }
  }
  shouldLog(checkLevel) {
    return this.isEnabled && checkLevel >= this.logLevel;
  }
}